import { render, staticRenderFns } from "./AccountTypeModal.vue?vue&type=template&id=6e8724d5&scoped=true"
import script from "./AccountTypeModal.vue?vue&type=script&lang=js"
export * from "./AccountTypeModal.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeModal.vue?vue&type=style&index=0&id=6e8724d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8724d5",
  null
  
)

export default component.exports